import React, { Component } from "react";
import uniqueId         from 'lodash/uniqueId';
import { FontAwesomeIcon }            from '@fortawesome/react-fontawesome'
//import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import "../../css/bootstrap/react-bootstrap-table-all.min.css";
import "../../css/bootstrap/react-bootstrap-table2.min.css";

// Docs: http://allenfang.github.io/react-bootstrap-table/
var ReactBsTable      = require('react-bootstrap-table');
var BootstrapTable    = ReactBsTable.BootstrapTable;
var TableHeaderColumn = ReactBsTable.TableHeaderColumn;

const products = [];

const options = {
    defaultSortName: 'date',
    defaultSortOrder: 'desc',
    bgColor: "#000"
 };


const optionsDaysLeftOnProgram = {
    defaultSortName: 'days_left',
    defaultSortOrder: 'asc',
    bgColor: "#000"
};

/********************  CELL EDIT *****************/
/*function onAfterSaveCell(row, cellName, cellValue) {
      //alert(`Save cell ${cellName} with value ${cellValue}`);
      let rowStr = '';
      for (const prop in row) {
        rowStr += prop + ': ' + row[prop] + '\n';
      }
      //alert('Thw whole row :\n' + rowStr);
}

function onBeforeSaveCell(row, cellName, cellValue) {
    return true;
}*

const selectRow = {
    mode: 'checkbox',   // required: checkbox || radio
    columnWidth: '1px', // hide column, no need to see it
    clickToSelect: true,
    bgColor: '#e0eefc',
    onSelect: (row, isSelect, rowIndex, e) => {
        console.log('=== selectRow row ===', row);
        console.log("program_id: " + row.program_id);

        var url = "client";
        var pid = row.program_id;
        var is_template = false;
        var client_name = row.username;
        var client_id   = 0;
        var member_url = '/'+url+'/detail/'+pid+'/'+is_template+'/'+client_name+'/'+client_id;
        //this.props.history.push(member_url);
        //this.gotoScreen();
    }
};*/

/*const cellEditProp = {
    mode: 'click',
    blurToSave: false,
    nonEditableRows: function() {
        // if product id less than 3, will cause the whole row noneditable
        // this function should return an array of row keys
        return
        //return table_data_arr.filter(p => p.id < 3).map(p => p.id);
    },
    beforeSaveCell: onBeforeSaveCell, // a hook for before saving cell
    afterSaveCell: onAfterSaveCell  // a hook for after saving cell
};*/

export default class DatagridTable extends Component {

    constructor(props) {
        super(props)

        /*this.state = {
            showModalSimple:  false,
        };*/
    }

    /*createTable () {

        addProducts(10);

        return  <span>
                    <BootstrapTable ref='table'
                                    data      = { products }
                                    maxHeight = {this.props.height}
                                    maxWidth  = {this.props.width}
                                    striped
                                    hover >
                            <TableHeaderColumn isKey={ true } dataField='id'    maxHeight = "25" data-formatter="imageFormatter" dataSort={ true }> ID</TableHeaderColumn>
                            <TableHeaderColumn dataField='name'  maxHeight = "25"  dataSort={ true }>Product</TableHeaderColumn>
                            <TableHeaderColumn dataField='price' maxHeight = "25"  tdStyle={ { content:`url(http://placehold.it/400x20)` } }>Price</TableHeaderColumn>
                    </BootstrapTable>
                </span>
    }*/

    getTableDaysLeftOnProgram () {
        var table_data_arr = []
        var data       = this.props.data;

        for(var key in data) {
            table_data_arr.push({
                row_id:       key,
                username:     data[key].athlete_name,
                user_id:      data[key].athlete_id,
                program_id:   data[key].program_id,
                program_name: data[key].program_name,
                days_left:    data[key].prog_days_left
            });
        }

        return table_data_arr;
    }

    priceFormatter(cell, row) {   // String example
        //console.log("----------  priceFormatter  -----------");
        //console.log("row: " + row);
        //console.log("cell: " + cell);
        return `<i class='glyphicon glyphicon-phone'></i>`;
    }

    isExpandableRow(row) {
        //console.log("isExpandableRow row.id: " + row.row_id);
      if (row.row_id < 2) return true;
        else return false;
    }

    expandComponent(row) {
      /*return (
        ...
      );*/
      console.log("expand comp");
    }

    createTableDaysLeftOnProgram () {
        var table_data_arr  = this.getTableDaysLeftOnProgram();

        return  <span>
                    <BootstrapTable ref       = 'table'
                                    options   = { optionsDaysLeftOnProgram }
                                    //cellEdit  = { cellEditProp }
                                    data      = { table_data_arr }
                                    maxHeight = { this.props.height }
                                    maxWidth  = { this.props.width }
                                    //expandComponent={ this.expandComponent }

                                    striped
                                    hover >

                                    { /*selectRow = {{  mode: 'checkbox',   // required: checkbox || radio
                                                    columnWidth: '1px', // hide column, no need to see it
                                                    clickToSelect: true,
                                                    clickToExpand: true,
                                                    onSelect: (row, isSelect, rowIndex, e) => {
                                                        // rowIndex is an object with all functions
                                                        //console.log('=== selectRow row ===', row);
                                                        var url = "client";
                                                        var pid = row.program_id;
                                                        var is_template = false;
                                                        var client_name = row.username;
                                                        var client_id   = row.user_id;
                                                        var member_url = '/'+url+'/detail/'+pid+'/'+is_template+'/'+client_name+'/'+client_id;

                                                        this.props.gotoScreen(member_url);
                                                    }
                                                }}*/ }
                            <TableHeaderColumn dataField='username'     maxHeight = "25"  isKey={ true }  dataSort={ true }>Athlete</TableHeaderColumn>
                            <TableHeaderColumn dataField='program_name' maxHeight = "25" >Program</TableHeaderColumn>
                            <TableHeaderColumn dataField='days_left'    maxHeight = "25" dataSort={ true }>Days Left on Program</TableHeaderColumn>
                            { /*}<TableHeaderColumn dataField='text_msg'     maxHeight = "25" width="40px" dataFormat={ this.priceFormatter }>Txt</TableHeaderColumn>*/ }

                    </BootstrapTable>
                </span>
    }

    getTableCompletedProgramsData () {
        var table_data_arr = []
        var data       = this.props.data;
        var old_user_id;

        var user_id_arr = [];
        var user_data_obj = {};
        var ctr = 0;
        for(var key in data) {
            var user_id = data[key].user_id;

            // Recode and fix database query; only show one record per user
            // Remove duplicate users below
            if(user_id != old_user_id) {
                var in_arr = user_id_arr.indexOf(user_id);

                if(in_arr == -1) {
                    var date      = new Date(data[key].date_created).toString().slice(0, 15);
                    var full_name = data[key].first_name + " " + data[key].last_name;
                    var program_name = data[key].program_name;

                    user_data_obj[ctr] = {};
                    user_data_obj[ctr].date         = date;
                    user_data_obj[ctr].full_name    = full_name;
                    user_data_obj[ctr].program_name = program_name;

                    user_id_arr.push(user_id);
                    ctr++;
                }
            }
            old_user_id = user_id;
        }

        for(var key2 in user_data_obj) {

            table_data_arr.push({
                date: user_data_obj[key2].date,
                username: user_data_obj[key2].full_name,
                program_name: user_data_obj[key2].program_name
            });
        }

        return this.sortDate(table_data_arr);
    }

    createTableCompletedPrograms () {
        var table_data_arr = this.getTableCompletedProgramsData();

        return  <span>
                    <BootstrapTable ref='table'
                                    data      = { table_data_arr }
                                    maxHeight = { this.props.height }
                                    maxWidth  = { this.props.width }
                                    striped
                                    hover >
                            <TableHeaderColumn dataField='username'     maxHeight = "25" width="30%" isKey={ true } dataSort={ true }>Athlete</TableHeaderColumn>
                            <TableHeaderColumn dataField='program_name' maxHeight = "25" >Program</TableHeaderColumn>
                            <TableHeaderColumn dataField='date'         maxHeight = "25" width="25%" dataSort dataSort={ true }>Date</TableHeaderColumn>
                    </BootstrapTable>
                </span>
    }

    sortDate(array) {
        array.sort(function(a,b){
          // Turn your strings into dates, and then subtract them
          // to get a value that is either negative, positive, or zero.
          return new Date(b.date) - new Date(a.date);
        });

        return array;
    }
    getTableCompletedWorkoutsData () {
        var table_data_arr = []
        var data       = this.props.data;

        for(var key in data) {
            var date = new Date(data[key].date_created).toString().slice(0, 15);

            table_data_arr.push({
                username: data[key].first_name + " " + data[key].last_name,
                program_name: data[key].program_name,
                date: date
            });
        }

        return this.sortDate(table_data_arr);
    }

    createTableCompletedWorkouts () {
        var table_data_arr = this.getTableCompletedWorkoutsData();
        const selectRow = {
            mode: 'checkbox',  // multi select
            columnWidth: '60px'
        };

        return  <span>
                    <BootstrapTable ref='table'
                                    //options   = { options }
                                    data      = { table_data_arr }
                                    maxHeight = { this.props.height }
                                    maxWidth  = { this.props.width }
                                    striped
                                    hover >
                            <TableHeaderColumn dataField='username'     maxHeight = "25" width = "30%" isKey={ true }  dataSort={ true }>Athlete</TableHeaderColumn>
                            <TableHeaderColumn dataField='program_name' maxHeight = "25" >Program</TableHeaderColumn>
                            <TableHeaderColumn dataField='date'         maxHeight = "25" width = "25%" dataFormat={ this.dateFormatter } dataSort={ true } >Date</TableHeaderColumn>
                    </BootstrapTable>
                </span>
    }

    getMeasureName (id) {
        var value ="";
        switch (id) {
            case 1:
                value = "Sets";
                break;
            case 2:
                value = "Repetitions (Reps)"
                break;
            case 3:
                value = "Rest"
                break;
            /*case 10 - Pounds (Lbs)
            case 11 - Kilograms (Kgs)
            case 12 - Percent of Max (%)

            case 20 - Time (Min:Sec)
            case 21 - Seconds (Secs)

            case  30 - Feet
            case 31 - Yards
            case 32 - Miles
            case 33 - Inches
            case 34 - Meters
            case 35 - Height in Inches (Height)
            case 36 - Laps

            case 40 - Calories (Cals)
            case 41 - Velocity in meters/second
            case 42 - Velocity miles/hour
            case 43 - Velocity kilometers/hour
            case 44 - Watts

            case 45 - Breaths*/
            default:
                value = "";
                break;
        }

        return value;

    }
    getTableHighest1RM () {
        var table_data_arr = []
        var data       = this.props.data;

        for(var key in data) {
            var date = new Date(data[key].date_created).toString().slice(0, 15);

            table_data_arr.push({
                username: data[key].first_name + " " + data[key].last_name,
                one_rep_max: data[key].one_rep_max,
                exercise_name: data[key].exercise_name,
                measure: this.getMeasureName(data[key].measure_id),
                date: date
            });
        }

        return this.sortDate(table_data_arr);
    }

    createTableHighest1RM () {
        var table_data_arr = this.getTableHighest1RM();

        return  <span>
                    <BootstrapTable ref='table'
                                    //options   = { options }
                                    data      = { table_data_arr }
                                    maxHeight = { this.props.height }
                                    maxWidth  = { this.props.width }
                                    striped
                                    hover >
                        <TableHeaderColumn dataField='username'      width="180px" maxHeight = "25"  isKey={ true }  dataSort={ true }>Athlete</TableHeaderColumn>
                        <TableHeaderColumn dataField='one_rep_max'   width="100px" maxHeight = "25" dataAlign='center'>1 Rep Max</TableHeaderColumn>
                        <TableHeaderColumn dataField='exercise_name' maxHeight = "25" >Exercise</TableHeaderColumn>
                        <TableHeaderColumn dataField='measure'       width="170px" maxHeight = "25" dataAlign='center'>Measure</TableHeaderColumn>
                        <TableHeaderColumn dataField='date'          maxHeight = "25" dataSort={ true }>Date</TableHeaderColumn>
                    </BootstrapTable>
                </span>
    }

    getTableNewClients () {
        var table_data_arr = []
        var data       = this.props.data;

        for(var key in data) {
            var date = new Date(data[key].date_created).toString().slice(0, 15);

            table_data_arr.push({
                username: data[key].first_name + " " + data[key].last_name,
                date: date
            });
        }

        return this.sortDate(table_data_arr);
    }

    createTableNewClients () {
        var table_data_arr = this.getTableNewClients();

        return  <span>
                    <BootstrapTable ref='table'
                                    data      = { table_data_arr }
                                    maxHeight = { this.props.height }
                                    maxWidth  = { this.props.width }
                                    striped
                                    hover >
                            <TableHeaderColumn dataField='username'     maxHeight = "25"  isKey={ true }  dataSort={ true }>Athlete</TableHeaderColumn>
                            <TableHeaderColumn dataField='date'         maxHeight = "25" dataSort={ true }>Date</TableHeaderColumn>
                    </BootstrapTable>
                </span>
    }

    getTableNewTemplates() {
        var table_data_arr = []
        var data       = this.props.data;

        for(var key in data) {
            var date = new Date(data[key].date_created).toString().slice(0, 15);

            table_data_arr.push({
                program_name: data[key].name,
                date: date
            });
        }

        return this.sortDate(table_data_arr);
    }

    getTableSingleClientAllPrograms() {
        var table_data_arr = []
        var data           = this.props.data;

        for(var key in data) {
            var date = new Date(data[key].date_created).toString().slice(0, 15);

            table_data_arr.push({
                program_name: data[key].name,
                program_uid: data[key].uid,
                date: date
            });
        }

        return this.sortDate(table_data_arr);
    }

    getTableSingleClientAllDocuments() {
        var table_data_arr = []
        var data           = this.props.data;
        if(data != undefined)

        for(var key in data.file_name) {
            var date = new Date(data.date[key]).toString().slice(0, 15);
            table_data_arr.push({
                title: data.file_name[key],
                uid: data.id[key],
                date: date
            });
        }

        return this.sortDate(table_data_arr);
    }

    getTableSingleClientAllAssessments() {
        var table_data_arr = []
        var data           = this.props.data;

        if(data != undefined)
        for(var key in data.title) {
            var date = new Date(data.date[key]).toString().slice(0, 15);

            table_data_arr.push({
                title: data.title[key],
                uid: data.id[key],
                date: date
            });
        }

        return this.sortDate(table_data_arr);
    }

    createTableNewTemplates () {
        var table_data_arr = this.getTableNewTemplates();

        return  <span>
                    <BootstrapTable ref='table'
                                    data      = { table_data_arr }
                                    maxHeight = { this.props.height }
                                    maxWidth  = { this.props.width }
                                    striped
                                    hover >
                            <TableHeaderColumn dataField='program_name' maxHeight = "25" isKey={ true }  dataSort={ true }>Program</TableHeaderColumn>
                            <TableHeaderColumn dataField='date'         maxHeight = "25" dataSort={ true }>Date</TableHeaderColumn>
                    </BootstrapTable>
                </span>
    }

    createTableSingleClientAllPrograms () {
        var table_data_arr = this.getTableSingleClientAllPrograms();

        return  <span>
                    <BootstrapTable ref='table'
                                    data      = { table_data_arr }
                                    maxHeight = { this.props.height }
                                    maxWidth  = { this.props.width }
                                    striped
                                    hover >
                            <TableHeaderColumn dataField='program_name' maxHeight = "25" isKey={ true }  dataSort={ true }>Title</TableHeaderColumn>
                            <TableHeaderColumn dataField='date'         maxHeight = "25" dataSort={ true }>Date</TableHeaderColumn>
                    </BootstrapTable>
                </span>
    }

    createTableSingleClientAllDocuments () {
        var table_data_arr = this.getTableSingleClientAllDocuments();

        return  <span>
                    <BootstrapTable ref='table'
                                    data      = { table_data_arr }
                                    maxHeight = { this.props.height }
                                    maxWidth  = { this.props.width }
                                    striped
                                    hover >
                            <TableHeaderColumn dataField='title' maxHeight = "25" isKey={ true }  dataSort={ true }>Title</TableHeaderColumn>
                            <TableHeaderColumn dataField='date'         maxHeight = "25" dataSort={ true }>Date</TableHeaderColumn>
                    </BootstrapTable>
                </span>
    }

    createTableSingleClientAllAssessments () {
        var table_data_arr = this.getTableSingleClientAllAssessments();

        return  <span>
                    <BootstrapTable ref='table'
                                    data      = { table_data_arr }
                                    maxHeight = { this.props.height }
                                    maxWidth  = { this.props.width }
                                    striped
                                    hover >
                            <TableHeaderColumn dataField='title' maxHeight = "25" isKey={ true }  dataSort={ true }>Title</TableHeaderColumn>
                            <TableHeaderColumn dataField='date'         maxHeight = "25" dataSort={ true }>Date</TableHeaderColumn>
                    </BootstrapTable>
                </span>
    }

    getTableNewPrograms() {
        var table_data_arr = []
        var data       = this.props.data;

        for(var key in data) {
            var date = new Date(data[key].date_created).toString().slice(0, 15);

            table_data_arr.push({
                program_name: data[key].program_name,
                date: date
            });
        }

         return this.sortDate(table_data_arr);
    }

    createTableNewPrograms () {
        var table_data_arr = this.getTableNewPrograms();

        return  <span>
                    <BootstrapTable ref='table'
                                    data      = { table_data_arr }
                                    maxHeight = { this.props.height }
                                    maxWidth  = { this.props.width }
                                    striped
                                    hover >
                            <TableHeaderColumn dataField='program_name' maxHeight = "25" isKey={ true }  dataSort={ true }>Program</TableHeaderColumn>
                            <TableHeaderColumn dataField='date'         maxHeight = "25" dataSort={ true }>Date</TableHeaderColumn>
                    </BootstrapTable>
                </span>
    }

    daysBetween ( date2 ) {
          var date1 = new Date();
          //Get 1 day in milliseconds
          var one_day=1000*60*60*24;

          // Convert both dates to milliseconds
          var date1_ms = date1.getTime();
          var date2_ms = date2.getTime();

          // Calculate the difference in milliseconds
          var difference_ms = date1_ms - date2_ms;

          // Convert back to days and return
          return Math.round(difference_ms/one_day);
    }

    getTableAthleteInactivity() {
        var table_data_arr = []
        var data       = this.props.data;

        for(var key in data) {
            var date = new Date(data[key].date_created);
            var days = this.daysBetween(date);

            table_data_arr.push({
                athlete: data[key].first_name + " " + data[key].last_name,
                date: days,
                login_date: date
            });
        }

        return table_data_arr;
    }

    createTableAthleteInactivity () {
        var table_data_arr = this.getTableAthleteInactivity();

        return  <span>
                    <BootstrapTable ref       = 'table'
                                    options   = { options }
                                    data      = { table_data_arr }
                                    maxHeight = { this.props.height }
                                    maxWidth  = { this.props.width }
                                    striped
                                    hover >
                            <TableHeaderColumn dataField='athlete' maxHeight = "25" isKey={ true }  dataSort={ true }>Athlete</TableHeaderColumn>
                            <TableHeaderColumn dataField='date'    maxHeight = "25" dataSort={ true } dataAlign='center' dataSort>Days Inactive</TableHeaderColumn>
                            <TableHeaderColumn dataField='login_date'    maxHeight = "25" dataSort={ true } dataSort>Last Login</TableHeaderColumn>
                    </BootstrapTable>
                </span>
    }

    render() {
        var screen = this.props.screen;
        var table; //  = this.createTable();
        if(screen === "days_left_on_program")
            table  = this.createTableDaysLeftOnProgram();
        else if(screen === "completed_workouts")
            table  = this.createTableCompletedWorkouts();
        else if(screen === "completed_programs")
            table  = this.createTableCompletedPrograms();
        else if(screen === "athlete_highest_1rm")
            table  = this.createTableHighest1RM();
        else if(screen === "athlete_inactivity")
            table  = this.createTableAthleteInactivity();
        else if(screen === "new_programs_created")
            table  = this.createTableNewPrograms();
        else if(screen === "new_clients_created")
            table  = this.createTableNewClients();
        else if(screen === "new_templates_created")
            table  = this.createTableNewTemplates();
        else if(screen === "single_client_all_programs")
            table  = this.createTableSingleClientAllPrograms();
        else if(screen === "single_client_all_assessments")
            table  = this.createTableSingleClientAllAssessments();
        else if(screen === "single_client_all_documents")
            table  = this.createTableSingleClientAllDocuments();

        return (
            <div>
                { table }
            </div>

        )
    }
}



// WEBPACK FOOTER //
// ./src/components/dashboard/DatagridTable.js